import(/* webpackMode: "eager" */ "/codebuild/output/src3121536383/src/next-app/app/global-error.tsx");
